import { TelegramAPISettings } from "../telegram_api_settings.js";
import { AppConfigService } from "../app_config/app_config_service.js";

export class TelegramWriteAccess
{
  private static readonly RETRY_MS = 7 * 24 * 60 * 60 * 1000;
  private static readonly DELAY_MS = 1500;
  private static readonly ASKED_AT_KEY = "telegram_write_access_asked_at";
  private static readonly GRANTED_KEY = "telegram_write_access_granted";

  private static requested = false;

  private constructor() {}

  public static maybeRequest( level: number, is_still_relevant: () => boolean ): void
  {
    const after_level = AppConfigService.get().bot_write_access_after_level;
    if ( TelegramWriteAccess.requested || after_level <= 0 || level <= after_level || !TelegramWriteAccess.canAsk() )
      return;

    TelegramWriteAccess.requested = true;
    setTimeout( () =>
    {
      if ( is_still_relevant() )
        TelegramWriteAccess.request();
      else
        TelegramWriteAccess.requested = false;
    }, TelegramWriteAccess.DELAY_MS );
  }

  private static canAsk(): boolean
  {
    const webapp = window.Telegram?.WebApp;
    if ( !webapp || !TelegramAPISettings.isTelegramEnvironment() || typeof webapp.requestWriteAccess !== "function" )
      return false;

    if ( typeof webapp.isVersionAtLeast === "function" && !webapp.isVersionAtLeast( "6.9" ) )
      return false;

    if ( webapp.initDataUnsafe?.user?.allows_write_to_pm || TelegramWriteAccess.read( TelegramWriteAccess.GRANTED_KEY ) )
      return false;

    const asked_at = Number( TelegramWriteAccess.read( TelegramWriteAccess.ASKED_AT_KEY ) ) || 0;
    return Date.now() - asked_at >= TelegramWriteAccess.RETRY_MS;
  }

  private static request(): void
  {
    TelegramWriteAccess.write( TelegramWriteAccess.ASKED_AT_KEY, String( Date.now() ) );

    try
    {
      window.Telegram?.WebApp?.requestWriteAccess?.( granted =>
      {
        if ( granted )
          TelegramWriteAccess.write( TelegramWriteAccess.GRANTED_KEY, "1" );
      } );
    }
    catch ( e )
    {
      console.warn( "[TelegramWriteAccess] request failed", e );
    }
  }

  private static read( key: string ): string | null
  {
    try
    {
      return localStorage.getItem( key );
    }
    catch
    {
      return null;
    }
  }

  private static write( key: string, value: string ): void
  {
    try
    {
      localStorage.setItem( key, value );
    }
    catch
    {
    }
  }
}
